/// <reference types="google.maps" />
import { importLibrary, setOptions } from '@googlemaps/js-api-loader';

let optionsSet = false;
let placesLibraryPromise: Promise<google.maps.PlacesLibrary> | null = null;

/**
 * Load the Google Maps Places library, memoizing across all callers.
 *
 * The script tag is shared globally — the first call locks in the API key
 * via `setOptions`. Subsequent calls with a different key are ignored
 * (Google Maps cannot rotate keys after the script has loaded).
 */
export const loadPlacesLibrary = (apiKey: string): Promise<google.maps.PlacesLibrary> => {
  if (!optionsSet) {
    setOptions({ key: apiKey, v: 'weekly' });
    optionsSet = true;
  }
  if (!placesLibraryPromise) {
    placesLibraryPromise = importLibrary('places');
  }
  return placesLibraryPromise;
};

/** Test-only: clear the memoized state so each test starts from scratch. */
export const __resetPlacesLibraryForTests = (): void => {
  optionsSet = false;
  placesLibraryPromise = null;
};
